import React from "react";
import classNames from "classnames";

import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { CalendarIcon } from "@common/dateTimeInput/calendarIcon";
import { SelectList } from "@common/selectList";
import { Years } from "./years";
import { Props } from "./types";
import styles from "./styles.scss";

function YearNavigation(props: Props) {
  const [cursor, setCursor] = React.useState(new Date(props.year, 0, 1));

  return (
    <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
      {({ isOpen, select }) => ({
        input: (
          <div className={styles.yearNavigation}>
            <div
              className={styles.arrow}
              onClick={(e) => {
                e.stopPropagation();
                props.setYear(props.year - 1);
              }}
            >
              <ToggleArrowIcon className={styles.leftArrow} />
            </div>
            <p className={styles.year}>{props.year}</p>
            <div
              className={styles.arrow}
              onClick={(e) => {
                e.stopPropagation();
                props.setYear(props.year + 1);
              }}
            >
              <ToggleArrowIcon className={styles.rightArrow} />
            </div>
            <div
              className={classNames(styles.calendarButton, {
                [styles.opened]: isOpen,
              })}
            >
              <CalendarIcon className={styles.calendarIcon} />
            </div>
          </div>
        ),
        list: (
          <Years
            year={props.year}
            cursor={cursor}
            editCursor={(year) => setCursor(new Date(year, 0, 1))}
            select={(year) => select(props.setYear(year))}
          />
        ),
      })}
    </SelectList>
  );
}

export { YearNavigation };
